import { motion, useScroll, useSpring, useReducedMotion } from "motion/react";

/**
 * Page's signature accent gesture: a 1px red bar fixed at the very top
 * of the viewport that fills as the user scrolls.
 */
const ScrollProgressBar = () => {
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.4 });

  if (reduce) return null;

  return (
    <motion.div
      aria-hidden
      style={{ scaleX, transformOrigin: "0% 50%" }}
      className="fixed top-0 left-0 right-0 h-px bg-accent z-[60]"
    />
  );
};

export default ScrollProgressBar;
